module.exports = __webpack_public_path__ + "static/media/Icons_CA-02.d9c538f8.svg";